import React, { useEffect, useState } from 'react'
import {
    Box,
    Typography,
    Button,
    Checkbox,
    FormControlLabel,
    Select,
    TextField,
    MenuItem,
    Dialog,
    DialogContent,
    IconButton,
    FormControl,
    RadioGroup,
    Radio,
    DialogActions,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Popover
} from '@mui/material'
import {
    ApiGetShopperList,
    ApiCriteriaMessage,
    ApiPostUpdateAppliedAllocationStatus,
    ApiGetVisitTimes,
    ApiAssignShooperAllocation,
    ApiGetApproveAllocationShopper,
    ApiGetAllocationWarning,
    ApiGetOrphanAllocations
} from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { CancelOutlined, Error } from '@mui/icons-material'
import { useNavigate, useParams } from 'react-router-dom'
import Dcrage from './Dcrage.tsx'
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts'


const AssignShopper = () => {
    const { id, currentdate } = useParams()
    const [selectedShopperId, setSelectedShopperId] = useState<string>('');
    const [selectedShopperName, setSelectedShopperName] = useState<string>('');
    const [shopperList, setShopperList] = useState<any[]>([])
    const [stateData, setStateData] = useState<any>(null)
    const [searchQuery, setSearchQuery] = useState('')
    const [errorMessages, seterrorMessages] = useState<any>([])
    const [iserror, setiserror] = useState<boolean>(false)
    const [visittimes, setvisittimes] = useState<any>([]);
    const [selectedVisitTime, setselectedVisitTime] = useState<any>(stateData ? stateData?.selectedVisitTime?.visitTimeId : null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSkipTraining, setIsSkipTraining] = useState<boolean>(false);
    const [previousShoppers, setpreviousShoppers] = useState<any>([]);
    const [futureShoppers, setfutureShoppers] = useState<any>([]);
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const navigate = useNavigate()
    const [selectedVisitDate, setSelectedVisitDate] = useState<Dayjs | null>(() => {
        if (currentdate) {
            return currentdate ? dayjs(currentdate) : dayjs();
        }
        return dayjs();
    });
    const [issueList, setIssueList] = useState<any>([])

    const fetchShoppers = async (query = '') => {
        try {
            const data = `?offset=0&limit=1000&status=active${query ? `&search=${query}` : ''}&allocationId=${stateData.allocationId}`;
            const res = await ApiGetShopperList(data);
            const filtered = res.data.filter(item =>
                item.firstName.trim() !== '' && item.lastName.trim() !== ''
            );
            setShopperList(filtered);
            setShowDropdown(query.length > 0 && filtered.length > 0);
        } catch (error) {
            console.error('Error fetching shoppers:', error);
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchShoppers(searchQuery);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchQuery]);

    // useEffect(() => {
    //     const storedDataUp = sessionStorage.getItem('inviteShopperState')
    //     if (storedDataUp) {
    //         setStateData(JSON.parse(storedDataUp))
    //     }
    // }, [])

    const ApiCallGetAllocations = async () => {
        let data = `?allocationId=${id}`

        try {
            const res: any = await ApiGetOrphanAllocations(data)
            setStateData(res?.data[0] || [])

        } catch (error) {
            toast.error("Failed to load allocations")
        }
    }

    useEffect(() => {
        id && ApiCallGetAllocations()
    }, [id])

    const handleSendAssign = async () => {
        if (!selectedShopperId) {
            toast.error('Please select a shopper first');
            return;
        }
        if (!selectedVisitDate) {
            toast.error('Please select a visit date');
            return;
        }
        if (!selectedVisitTime) {
            toast.error('Please select a visit time');
            return;
        }
        const data = {
            userId: selectedShopperId,
            allocationId: stateData?.allocationId,
            selectedVisitDate: selectedVisitDate.format('YYYY-MM-DD'),
            selectedVisitTime: selectedVisitTime,
            ...(isSkipTraining && { isSkipTraining: true })
        }
        console.log("Assign Data", data)
        // if (errorMessages.length <= 0) {
        //     alert("Call APi")

        // }
        try {
            const response = await ApiAssignShooperAllocation(data)
            toast.success(response?.message)
            setSelectedShopperId('');
            setSelectedShopperName('');
            setselectedVisitTime(null);
            setIsSkipTraining(false);

            if (window.opener && !window.opener.closed) {
                // hard reload the parent
                window.opener.location.reload();
                // or React Router v6: window.opener.location.href = window.opener.location.href;
            }
            setTimeout(() => window.close(), 300);
            // navigate('/admin/manage-reports')
        }
        catch (error: any) {
            console.error('Assignment error:', error);
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message);
        }
    }
    const handlecriteriamessage = async () => {
        seterrorMessages([])
        if (errorMessages.length <= 0) {
            const data = `?userId=${selectedShopperId}&allocationId=${stateData.allocationId}&clientEntityId=${stateData?.venueId?.clientEntityId?.clientEntityId}`

            try {
                const response = await ApiCriteriaMessage(data)
                console.log(response.data)
                const tempErrors: any = [];
                response.data.map((item: any, index: number) => {
                    if (item.allocationCriteriaFailures.length > 0) {
                        tempErrors.push({

                            username: item.username,
                            messages: item.allocationCriteriaFailures

                        })
                    }
                })
                seterrorMessages(tempErrors)
                if (tempErrors.length <= 0) { handleSendAssign() }
            }
            catch (error: any) {
                console.error('Error updating store:', error)
                toast.error(error);
            }

        }
    }

    useEffect(() => {
        errorMessages.length > 0 ? setiserror(true) : setiserror(false)
    }, [errorMessages])
    useEffect(() => {
        const gettimes = async () => {

            try {
                const res = await ApiGetVisitTimes()
                setvisittimes(res.data)
            } catch (error) {

            }
        }
        gettimes()
    }, [])

    useEffect(() => {

        const getpreviousShoppers = async () => {
            try {
                const data = `?venueId=${stateData?.venueId?.venueId}&jobMonth=${stateData?.jobMonth}&jobYear=${stateData?.jobYear}`
                const res = await ApiGetApproveAllocationShopper(data)
                if (res?.status) {
                    setpreviousShoppers(res?.data?.previousMonth)
                    setfutureShoppers(res?.data?.futureMonth)
                }
            } catch (error: any) {
                toast.error(error?.message)
            }
        }
        stateData && getpreviousShoppers()
    }, [stateData])

    useEffect(() => {

        const getissues = async () => {
            try {
                const data = `?allocationId=${stateData?.allocationId}&clientEntityId=${stateData?.clientEntityId?.clientEntityId}&shopperId=${selectedShopperId}${selectedVisitDate ? `&selectedVisitDate=${selectedVisitDate.toISOString().replace("T", " ").slice(0, 19)}` : ""} ${selectedVisitTime ? `&selectedVisitTime=${selectedVisitTime}` : ""}`
                const res = await ApiGetAllocationWarning(data)
                if (res?.success || res?.status) {
                    setIssueList(res?.data)
                }

            } catch (error: any) {
                toast.error(error?.message)
            }
        }
        if (selectedShopperId) {
            getissues()
        }
        if (!selectedShopperId) {
            setIssueList([])
        }
    }, [selectedShopperId, selectedVisitTime, selectedVisitDate])
    console.log("Selected ShopperId", selectedShopperId)

    return (
        <div className='invite-shopper' >
            <h1 className='common-add' style={{ textAlign: 'center' }}>
                Orphan Allocation - Assign-Shopper
            </h1>
            <div>
                <div className='d-flex align-items-center justify-content-between'>
                    <div>
                        <Typography variant='h6' gutterBottom>
                            {stateData?.venueId?.venueName}
                        </Typography>
                        <Typography>
                            <b>Address:</b> {stateData?.venueId?.address} {stateData?.venueId?.city}  {stateData?.venueId?.suburb ? `,${stateData?.venueId?.suburb},` : ''} {stateData?.venueId?.state} {stateData?.venueId?.postalCode}
                        </Typography>
                        {/* <Typography>
                    <b>Postcode:</b> {stateData?.venueId?.postalCode}
                </Typography> */}
                        <Typography>
                            <b>Trading hours:</b> {stateData?.venueId?.tradingHours}
                        </Typography>
                        <Typography>
                            <b>Website:</b>
                            <a href={stateData?.venueId?.websiteURL}>
                                {stateData?.venueId?.websiteURL}
                            </a>
                        </Typography>
                        <Typography>
                            <b>Price:</b> {stateData?.allocationPriceDisplay ? stateData?.allocationPriceDisplay : `$${stateData?.allocationPrice}`}
                        </Typography>
                    </div>
                    <div className='d-flex flex-column' style={{ gap: "20px" }}>
                        <div>
                            <h6 className='mb-2' style={{ fontWeight: "700" }}>Previous Shoppers:</h6>
                            <div className='d-flex align-items-center' style={{ gap: "20px" }}>
                                {[...previousShoppers]
                                    ?.reverse()?.map((item: any) => (
                                        <div className='p-3 2 d-flex flex-column align-items-center border-10' style={{ gap: "10px", background: "#ADB792", cursor: "pointer" }}
                                            onClick={(e) => handleShopperDetailsClick(e, item.shopperId)}
                                        >
                                            <div className="bg-light p-2 px-4 border-10">
                                                <p className='text-center'>{item?.shopperFirstName} {item?.shopperLastName}</p>
                                                <p className='text-center'>{item?.month}-{item?.year}</p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                        <div>
                            <h6 className='mb-2' style={{ fontWeight: "700" }}>Future Shoppers:</h6>
                            <div className='d-flex align-items-center' style={{ gap: "20px" }}>
                                {[...futureShoppers]
                                    ?.reverse()?.map((item: any) => (
                                        <div className='p-3 2 d-flex flex-column align-items-center border-10' style={{ gap: "10px", background: "#ADB792", cursor: "pointer" }}
                                            onClick={(e) => handleShopperDetailsClick(e, item?.shopperId)}
                                        >
                                            <div className="bg-light p-2 px-4 border-10">
                                                <p className='text-center'>{item?.shopperFirstName} {item?.shopperLastName}</p>
                                                <p className='text-center'>{item?.month}-{item?.year}</p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>

                <hr />
                <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='stretch'>
                    <Box className='px-2 d-flex align-items-center' borderRight='1px solid #ccc'>
                        <Typography fontWeight='bold' variant='body1'>Visit Date</Typography>
                    </Box>
                    <Box className='d-flex extra justify-content-start px-2'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <StaticDatePicker

                                sx={{
                                    "& .MuiPickersCalendarHeader-switchViewButton":
                                    {
                                        // display: "none",
                                    },
                                    "& .MuiPickersArrowSwitcher-root": {
                                        // display: "none",
                                    },
                                    "& .MuiPickersDay-root.Mui-selected": {
                                        backgroundColor: "#ADB792 !important",
                                        borderRadius: '10px'
                                    },
                                    "& .MuiPickersCalendarHeader-labelContainer":
                                    {
                                        pointerEvents: "none",
                                    },
                                }}
                                shouldDisableDate={(date) => {
                                    return !dayjs(date).isSame(selectedVisitDate, 'month');
                                }}
                                slots={{
                                    actionBar: () => null
                                }}
                                className='m-0' onChange={(newValue) => setSelectedVisitDate(newValue)} value={selectedVisitDate} />
                        </LocalizationProvider>
                    </Box>
                </Box>
                <Box display='grid' borderBottom='1px solid #ccc' gridTemplateColumns='200px 1fr' alignItems='center'>
                    <Box className='px-2 py-3' borderRight='1px solid #ccc'>
                        <Typography fontWeight='bold' variant='body1'>Visit Time</Typography>
                    </Box>
                    <Box className='px-2' >


                        <FormControl key={selectedVisitTime}>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                row
                                defaultValue={stateData?.selectedVisitTime?.visitTimeId}
                                value={selectedVisitTime ?? stateData?.selectedVisitTime?.visitTimeId}
                                onChange={(e) => { setselectedVisitTime(e.target.value) }}
                                name="radio-buttons-group"
                            >
                                {visittimes?.map((item: any, index: number) => (
                                    <FormControlLabel value={item.visitTimeId} control={<Radio />} label={item?.visitTimeInformation} />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>
                <hr />
                <Box className="border">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isSkipTraining}
                                onChange={(e) => setIsSkipTraining(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Do you want this shopper to skip training?"
                    />
                </Box>
                <Box sx={{ position: 'relative' }}>
                    <TextField
                        fullWidth
                        label="Search and Select Shopper"
                        value={selectedShopperId ? selectedShopperName : searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                            if (!e.target.value) {
                                setSelectedShopperId('');
                                setSelectedShopperName('');
                            }
                        }}
                        onFocus={() => searchQuery && setShowDropdown(true)}
                        InputProps={{
                            endAdornment: selectedShopperId && (
                                <IconButton
                                    size="small"
                                    onClick={() => {
                                        setSelectedShopperId('');
                                        setSelectedShopperName('');
                                        setSearchQuery('');
                                    }}
                                >
                                    <CancelOutlined fontSize="small" />
                                </IconButton>
                            )
                        }}
                    />
                    {showDropdown && shopperList.length > 0 && (
                        <Box sx={{
                            // position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            zIndex: 1,
                            bgcolor: 'background.paper',
                            maxHeight: 250,
                            overflow: 'auto',
                            border: '1px solid #ccc',
                            boxShadow: 3
                        }}>
                            {shopperList.map((shopper) => (
                                <MenuItem
                                    key={shopper.userId}
                                    onClick={() => {
                                        setSelectedShopperId(shopper.userId);
                                        setSelectedShopperName(`${shopper.firstName} ${shopper.lastName} (${shopper.userName}) (${shopper.emailId}) (${shopper.contactNo})`);
                                        setSearchQuery('');
                                        setShowDropdown(false);
                                    }}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        '&:hover': { bgcolor: '#f5f5f5' }
                                    }}
                                >
                                    <span>{shopper.firstName} {shopper.lastName} ({shopper.userName}) ({shopper.emailId}) ({shopper.contactNo})</span>
                                </MenuItem>
                            ))}
                        </Box>
                    )}
                </Box>
                {issueList?.warnings?.length > 0 && (
                    <List dense>
                        {issueList?.warnings.map((issue: any, index: number) => (
                            <ListItem key={index} sx={{ px: 0 }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>
                                    <Error sx={{ color: "error.main", fontSize: 20 }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={issue}
                                    primaryTypographyProps={{
                                        variant: "body2",
                                        color: "text.primary",
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
                <hr />
                <div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        Please Search Shopper (Shoppername)
                        <Button
                            variant='contained'
                            color='primary'
                            size='small'
                            className='table-row-background'
                            style={{ marginBottom: '0px', width: '200px' }}
                            onClick={handlecriteriamessage}
                        >
                            Assign selected shopper
                        </Button>
                    </div>
                    <hr />
                </div>
            </div>
            {errorMessages.length > 0 && (
                <Dialog open={iserror}>
                    <DialogContent>
                        <Box className='d-flex mb- p-0 align-items-center mb-3' gap={5}>
                            <Typography className='text-center text-danger' fontWeight='bold' variant='h5'>Error Reasons</Typography>
                            <IconButton onClick={() => {
                                setiserror(false);
                                setSelectedShopperId('');
                                setSelectedShopperName('');
                                setSearchQuery('');
                            }}><CancelOutlined /></IconButton>
                        </Box>
                        <Box className='p-1'>
                            {errorMessages.map((item: any, index: number) => (
                                <Box className='mb-2'>
                                    <Typography fontWeight='bold' variant='h6'>{item.username}</Typography>
                                    <ul className='pl-2'>
                                        {item.messages.map((msg: any, index: number) => (
                                            <li><Typography variant='subtitle2' key={index}>{msg}</Typography></li>
                                        ))}
                                    </ul>
                                </Box>
                            ))}
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
                        <Button
                            variant="outlined"
                            sx={{ color: '#75724C', borderColor: '#75724C' }}
                            onClick={() => {
                                setiserror(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            className='table-row-background'
                            onClick={() => {
                                setiserror(false);
                                handleSendAssign();
                            }}
                        >
                            Proceed
                        </Button>
                    </DialogActions>
                </Dialog>)}
            <Popover
                // open={Boolean(anchorEl) && selectedIndex === index}
                open={Boolean(anchorEl) && clickedShopperId !== null}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Dcrage handleClose={handleClose} loanData={loanData} />
            </Popover>
        </div>
    )
}

export default AssignShopper
